import CitySEOHead from "@/components/feature/CitySEOHead";
import PensacolaHeroSection from "./components/HeroSection";
import PensacolaStickyNav from "./components/StickyNav";
import PensacolaProcessingTimeSection from "./components/ProcessingTimeSection";
import PensacolaServicesSection from "./components/ServicesSection";
import PensacolaLocalAreaSection from "./components/LocalAreaSection";
import PensacolaTestimonialsSection from "./components/TestimonialsSection";
import PensacolaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PensacolaComparisonSection from "./components/ComparisonSection";
import PensacolaMistakesSection from "./components/MistakesSection";
import PensacolaHowItWorksSection from "./components/HowItWorksSection";
import PensacolaFAQSection, { faqs } from "./components/FAQSection";
import PensacolaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PensacolaFinalCTA from "./components/FinalCTA";
import PensacolaTravelTimingSection from "./components/TravelTimingSection";
import PensacolaDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Pensacola, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Pensacola, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving the western Florida Panhandle, Escambia County, NAS Pensacola military families, and Emerald Coast travelers needing urgent passport help.";

const areaServedList = [
  { "@type": "City", name: "Pensacola" },
  { "@type": "City", name: "Pensacola Beach" },
  { "@type": "City", name: "Gulf Breeze" },
  { "@type": "City", name: "Navarre" },
  { "@type": "City", name: "Perdido Key" },
  { "@type": "City", name: "Pace" },
  { "@type": "City", name: "Milton" },
  { "@type": "AdministrativeArea", name: "Escambia County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Pensacola, Gulf Breeze, Navarre, and Escambia County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PensacolaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Pensacola"
        state="Florida"
        stateAbbr="FL"
        route="/cities/pensacola"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Pensacola, Florida"
        geoPosition="30.4213;-87.2169"
        keywords="expedited passport Pensacola, emergency passport Pensacola FL, same day passport Pensacola, fast passport Florida, passport renewal Pensacola, Florida Panhandle passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
      />
      <PensacolaHeroSection />
      <PensacolaStickyNav />
      <PensacolaLocalAreaSection />
      <PensacolaProcessingTimeSection />
      <PensacolaServicesSection />
      <PensacolaTravelTimingSection />
      <PensacolaDestinationsSection />
      <PensacolaTestimonialsSection />
      <PensacolaAcceptanceFacilitiesSection />
      <PensacolaComparisonSection />
      <PensacolaMistakesSection />
      <PensacolaHowItWorksSection />
      <PensacolaFAQSection />
      <PensacolaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/pensacola" state="FL" />
      <PensacolaFinalCTA />
    </div>
  );
}